
export default {
  props: {
    colConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};